import React, { useState } from 'react';
import Plot from 'react-plotly.js';
import PropTypes from 'prop-types';
import { Select, message } from 'antd';

const { Option } = Select;

const SurfacePlot3D = ({ surfaceVectors, labels }) => {
    const [selectedAssets, setSelectedAssets] = useState([labels[0], labels[1], labels[2]]);

    if (!surfaceVectors || surfaceVectors.length === 0) {
        return <div>No data available</div>;
    }

    // Get the indices of the selected assets
    const selectedIndices = selectedAssets.map(asset => labels.indexOf(asset));

    // Filter surfaceVectors to get data for selected assets only
    const zData = surfaceVectors.filter((_, index) => selectedIndices.includes(index));
    const xLabels = selectedAssets;
    const yLabels = selectedAssets;

    const handleSelectChange = (value) => {
        if (value.length > 3) {
            message.error("Please select exactly three assets.");
        } else {
            setSelectedAssets(value);
        }
    };

    return (
        <div>
            <Select
                mode="multiple"
                style={{ width: '100%', marginBottom: '20px' }}
                placeholder="Select three assets to plot"
                value={selectedAssets}
                onChange={handleSelectChange}
            >
                {labels.map((label) => (
                    <Option key={label} value={label}>
                        {label}
                    </Option>
                ))}
            </Select>

            {selectedAssets.length === 3 && (
                <Plot
                    data={[
                        {
                            z: zData,
                            x: xLabels,
                            y: yLabels,
                            type: 'surface',
                            colorscale: 'Viridis', // Use a visually appealing color scale
                        },
                    ]}
                    layout={{
                        autosize: true,
                        width: '100%',
                        height: 500, // Set a fixed height to make the chart more compact
                        margin: {
                            l: 10,  // Left margin
                            r: 10,  // Right margin
                            b: 10,  // Bottom margin
                            t: 30,  // Top margin (adjust title spacing if needed)
                        },
                        scene: {
                            xaxis: { title: selectedAssets[0] },
                            yaxis: { title: selectedAssets[1] },
                            zaxis: { title: selectedAssets[2] },
                            camera: {
                                eye: {
                                    x: 1.5,
                                    y: 1.5,
                                    z: 0.7,
                                },
                            },
                        },
                    }}
                    config={{ displayModeBar: false }}  // Hide the toolbar
                />
            )}
        </div>
    );
};

SurfacePlot3D.propTypes = {
    surfaceVectors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SurfacePlot3D;

// Usage example:
// <SurfacePlot3D surfaceVectors={data.surface_vectors} labels={data.labels} />
